import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPercentage',
})
export class PercentageFormatPipe implements PipeTransform {
  transform(percentage?: number, round?: boolean): string {
    if (!percentage) {
      return '';
    }
    const formatValue = () => (round ? Math.round(percentage) : percentage);
    return new Intl.NumberFormat([], {
      localeMatcher: 'best fit',
      style: 'unit',
      unit: 'percent',
    }).format(formatValue());
  }
}
